import { createLogic } from 'redux-logic';
import { captureErrorInSentry } from 'lib/captureInSentry';

const handleLogicErrors = createLogic({
  type: 'UNHANDLED_LOGIC_ERROR',
  process({ action }, _dispatch, done) {
    const { payload: logicError } = action;
    captureErrorInSentry(logicError);
    done();
  },
});

export default handleLogicErrors;
